// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__17FzR","question":"Question_question__gs6pS","description":"Question_description__2ys_h"};